import React from "react";
import { createRoot } from "react-dom/client";
import { initI18n } from "./i18n/index.js";
import { App } from "./App.js";

// Explicit call, not a side effect of the import: i18next initialisation
// needs a browser (localStorage, navigator), and this module is imported by
// components that plain-Node tests import too. See initI18n's doc comment.
initI18n();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
